import { render, staticRenderFns } from "./SymptomsLabel.vue?vue&type=template&id=709b6a0a&scoped=true"
import script from "./SymptomsLabel.vue?vue&type=script&lang=js"
export * from "./SymptomsLabel.vue?vue&type=script&lang=js"
import style0 from "./SymptomsLabel.vue?vue&type=style&index=0&id=709b6a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b6a0a",
  null
  
)

export default component.exports